var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    width: 18,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.157 1.157l11.556 11.556m-11.556 0L12.713 1.157",
    fill: "none",
    fillRule: "evenodd",
    stroke: "current",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,ICA8c3ZnIGhlaWdodD0iMTUiIHdpZHRoPSIxOCI+CiAgICA8cGF0aAogICAgICBkPSJNMS4xNTcgMS4xNTdsMTEuNTU2IDExLjU1Nm0tMTEuNTU2IDBMMTIuNzEzIDEuMTU3IgogICAgICBmaWxsPSJub25lIgogICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgIHN0cm9rZT0iY3VycmVudCIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAvPgogIDwvc3ZnPg==";